import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const strong: SugarElementInfo = { name: "strong", availableChildren: { type: AvailableChildrenType.Any } };
